module.exports = __webpack_public_path__ + "static/brtvljenje-za-sve-instalacije-1a09a9a4134847c231a9f0462e32d223.png";